import log from '@shared/utils/Log';
const PENDO_APP_ID = '0bf9feab-a219-417f-515f-391beeeb147d';
let initialized = false;

export function initPendo(user) {
  if (initialized || typeof window === 'undefined' || !user) return;
  initialized = true;

  (function (p, e, n, d, o) {
    var v, w, x, y, z;
    o = p[d] = p[d] || {};
    o._q = o._q || [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track', 'trackAgent'];
    for (w = 0, x = v.length; w < x; ++w) (function (m) {
      o[m] = o[m] || function () {
        o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
      };
    })(v[w]);
    y = e.createElement(n);
    y.async = !0;
    y.src = 'https://cdn.pendo.io/agent/static/' + PENDO_APP_ID + '/pendo.js';
    z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');
  
  const visitorId = user.cj_cid || 0;
  const accountId = user.cj_social_unique_id || 0;

  // log('green', 'Initializing Pendo with visitorId:' + visitorId + ', and accountId:' + accountId);

  window.pendo.initialize({
    visitor: { id: visitorId },
    account: { id: accountId },
  });
}
